import {GetBeneficiaryDocumentUrl} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetBeneficiaryDocumentUrl} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const makeGetBeneficiaryDocumentUrl = (): GetBeneficiaryDocumentUrl =>
	new RemoteGetBeneficiaryDocumentUrl(
		makeBFFApiUrl(ExternalLinkPoint.beneficiaryDocument),
		makeAuthorizeHttpClientDecorator(),
	);
